import { flattenDeep } from 'lodash'
import { change, destroy, getFormValues } from 'redux-form'
import * as Effects from 'redux-saga/effects'
import {
  ICreateReservationFormValues,
  IFormService,
} from '../../../containers/Form/CreateReservation/CreateReservation'
import { IService } from '../../../models/Services'
import { IStore } from '../../../reducers'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'
import { getServices } from '../../../reducers/bookingCalendar/selectors/getServices'
import { getInvoiceSettings } from '../../../reducers/paymentDictionary/selectors/getPaymentDictionary'
import { IInvoiceSettings } from '../../../models/PaymentDictionary'

function* addService(action) {
  const services: IService[] = yield Effects.select(getServices)
  const getForm = getFormValues(action.form)
  const values: ICreateReservationFormValues = yield Effects.select(getForm)
  const config: IInvoiceSettings = yield Effects.select(getInvoiceSettings)
  const rates = yield Effects.select(
    (state: IStore) =>
      state.bookingCalendar.reservationModal.servicesModal.rates,
  )

  const newVal = {}

  Object.keys(action.values).forEach(key => {
    newVal[key.replace('s', '')] = action.values[key]
  })

  const serv = flattenDeep(
    Object.keys(newVal).map(key =>
      services.filter(
        service => newVal[key] && Number(service.id) === Number(key),
      ),
    ),
  ).map(service => {
    const tax = rates.find(
      rate => String(rate.id) === String((service as any).tax),
    )
    const secondTax = rates.find(
      rate => String(rate.id) === String((service as any).secondTax),
    )
    return {
      count: (service as any).default,
      id: (service as any).id,
      name: (service as any).serviceName,
      price: (service as any).price.toFixed(2).replace(',', '.'),
      secondTax: secondTax && config.activeSecondTax ? secondTax.rate : '',
      tax: tax && config.activeTax ? tax.rate : '',
    }
  })

  if (values.services) {
    const nextValues = [
      ...(values.services as IFormService[]).map(val => {
        const nextService = (serv as IFormService[]).find(
          addServ => addServ.id === val.id,
        )
        if (nextService) {
          return {
            ...val,
            count: val.count + 1,
          }
        } else {
          return val
        }
      }),
      ...serv,
    ]

    yield Effects.put(change(action.form, 'services', nextValues, true))
  } else {
    yield Effects.put(change(action.form, 'services', serv))
  }
  yield Effects.put(destroy('services'))
}

export default function* () {
  yield Effects.takeLatest(
    ReservationModalActions.AddServicesToForm,
    addService,
  )
}
